import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ListItemContentTitle from './ListItemContentTitle';
import ListItemContentDetail from './ListItemContentDetail';

const ListItemContent = (props) => {
  const boxIdClass = classNames({
    highlight: props.isHighlighted,
  });

  const {
    box,
    details,
    thumbnail,
    title,
  } = props;

  return (
    <React.Fragment>
      <ListItemContentTitle
        box={box}
        boxIdClass={boxIdClass}
        title={title}
      />
      <div
        className="help-side-bar-list-item help-side-bar-list-item-details"
        key={`content-${title}`}
      >
        {details.map(detail => (
          <ListItemContentDetail detail={detail} />
        ))}
        {thumbnail &&
          <img
            alt=""
            className="help-sidebar-thumbnail"
            src={thumbnail}
          />
        }
      </div>
    </React.Fragment>
  );
};

ListItemContent.defaultProps = {
  isHighlighted: false,
  thumbnail: '',
};

ListItemContent.propTypes = {
  box: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(PropTypes.string).isRequired,
  isHighlighted: PropTypes.bool,
  thumbnail: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default ListItemContent;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/components/ListItemContent.jsx